import { render, staticRenderFns } from "./city-popover-x.vue?vue&type=template&id=4e04388a&scoped=true"
import script from "./city-popover-x.vue?vue&type=script&lang=js"
export * from "./city-popover-x.vue?vue&type=script&lang=js"
import style0 from "./city-popover-x.vue?vue&type=style&index=0&id=4e04388a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e04388a",
  null
  
)

export default component.exports